import * as React from 'react';
import { StatusIndicator } from '../shared/StatusIndicator';
import { LiveSiteEventState } from '../../models/status';
import { SvgProps } from '../../models/ui/svg';

/**
 * Display the icon and meaning of each severity and lack thereof
 */
export const StatusLegend = () => {
    const inlineStyle: React.CSSProperties = {
        display: 'inline-block',
        marginRight: '12px'
    };
    const active: LiveSiteEventState = 'Active';
    const svgStyles: SvgProps = {
        width: 16,
        height: 16,
        className: 'sm-status-icon'
    };

    return (
        <>
            {/* Healthy */}
            <StatusIndicator state={'Resolved'} severity={undefined} inline={true} style={inlineStyle} svgStyles={svgStyles} />
            {/* Advisory */}
            <StatusIndicator state={active} severity={'Advisory'} inline={true} style={inlineStyle} svgStyles={svgStyles} />
            {/* Degraded */}
            <StatusIndicator state={active} severity={'Degraded'} inline={true} style={inlineStyle} svgStyles={svgStyles} />
            {/* Unhealthy */}
            <StatusIndicator state={active} severity={'Unhealthy'} inline={true} style={inlineStyle} svgStyles={svgStyles} />
            {/* Not Applicable */}
            <StatusIndicator state={undefined} severity={undefined} inline={true} style={inlineStyle} svgStyles={svgStyles} />
        </>
    );
};